import { Input as AntdInput } from 'antd'
import type { PasswordProps } from 'antd/lib/input'

export function PasswordInput(props: PasswordProps) {
  return <AntdInput.Password {...props} />
}
